exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-success .card-header[data-v-0a505b20]{background-color:#28a745;color:#fff}.card-danger .card-header[data-v-0a505b20]{background-color:#dc3545;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a505b20","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/Checkout/CheckoutComplete.vue
// module id = 2387
// module chunks = 1